import cn from "classnames";

export const Button = ({
  onClick = () => {},
  disabled = false,
  children,
  className="",
  ...btnProps
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "rounded-full bg-buddha-gold border py-[10px] px-7",
        "sm:py-[10px] sm:text-lg",
        "min-w-[200px] text-center",
        {
          "opacity-50 cursor-not-allowed": disabled,
        },
        className
      )}
      disabled={disabled}
      {...btnProps}
    >
      {children}
    </button>
  );
};
